import { render } from "./Breadcrumbs.vue?vue&type=template&id=7dd0c64c&scoped=true"
const script = {}

import "./Breadcrumbs.vue?vue&type=style&index=0&id=7dd0c64c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd0c64c"]])

export default __exports__